import { PersonProjectAllocations } from '../PersonProjectAllocations';
import { PersonTasksSection } from '../PersonTasksSection';
import { SkeletonList, SkeletonTable } from '../../ui/Skeleton';
import type { PersonTasksResult } from '../../../lib/peopleApi';

export interface PersonTasksTabProps {
  workload?: PersonTasksResult;
  workloadLoading: boolean;
  workloadError: boolean;
  /** The person's display name, for the task rows' avatar. */
  personName?: string;
}

/**
 * Tasks tab for the Team Member detail page (CLE-237). Shows the person's
 * task-derived project allocations plus the full filterable task list, mirroring
 * the Project Detail "Tasks" tab.
 */
export function PersonTasksTab({
  workload,
  workloadLoading,
  workloadError,
  personName,
}: PersonTasksTabProps) {
  if (workloadLoading) {
    return (
      <div className="space-y-6">
        <SkeletonTable rows={3} columns={5} />
        <SkeletonList rows={6} badge />
      </div>
    );
  }
  if (workloadError || !workload) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-4 text-sm text-gray-500 shadow-sm">
        Volumul de sarcini pentru această persoană nu a putut fi încărcat.
      </div>
    );
  }
  return (
    <div className="space-y-6">
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h2 className="mb-3 font-semibold text-gray-800">Alocări pe proiecte</h2>
        <PersonProjectAllocations allocations={workload.allocations} />
      </div>
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h2 className="mb-3 font-semibold text-gray-800">Toate sarcinile</h2>
        <PersonTasksSection data={workload} assigneeName={personName ?? null} />
      </div>
    </div>
  );
}
